import { createContext } from 'react';

const AuthAppContext = createContext();

export default AuthAppContext;
